import React from 'react';
import { SlicedSuggestions } from 'types/suggestions';
import { SponsoredProduct } from 'types/sponsored-products';
import { useSuggestionsButtonAction } from '../../hooks/use-suggestions-button-action';
import { getSponsoredElementIndex } from '../utils/get-element-index';
import { SponsoredListItemProduct } from './sponsored-list-item-product';

export type SponsoredProductsItemsProps = {
  sponsoredProducts: Array<SponsoredProduct & { contentId: string }>;
  suggestions: SlicedSuggestions;
  isDefaultList: boolean;
  index: number;
  isSrp: boolean;
  searchQuery: string;
  buttonAction: ReturnType<typeof useSuggestionsButtonAction>;
  akinatorOffset: number;
  defaultListPinnedOffset: number;
  newSuggestionsBeforeSponsored?: number;
};

export const SponsoredProductsItems: React.FC<SponsoredProductsItemsProps> = ({
  sponsoredProducts,
  suggestions,
  isDefaultList,
  index,
  isSrp,
  searchQuery,
  buttonAction,
  akinatorOffset,
  defaultListPinnedOffset,
  newSuggestionsBeforeSponsored,
}) => {
  if (sponsoredProducts.length === 0) return null;

  return (
    <div>
      {sponsoredProducts.map((product, productIndex) => (
        <SponsoredListItemProduct
          key={product.productId}
          elementIndex={getSponsoredElementIndex(
            productIndex,
            suggestions,
            isDefaultList,
            akinatorOffset,
            defaultListPinnedOffset,
            newSuggestionsBeforeSponsored,
          )}
          navigationIndex={index}
          isSrp={isSrp}
          buttonAction={buttonAction}
          productPosition={productIndex + 1}
          {...product}
          searchQuery={searchQuery}
        />
      ))}
    </div>
  );
};
